import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, addDays } from 'date-fns';

const HireDurationStep = ({ formData, handleInputChange, errors }) => {
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    if (formData.deliveryDate) {
      setStartDate(new Date(formData.deliveryDate));
    }
  }, [formData.deliveryDate]);

  const handleDateChange = (date) => {
    setStartDate(date);
    const formattedDate = format(date, 'yyyy-MM-dd');
    handleInputChange({
      target: {
        name: 'deliveryDate',
        value: formattedDate
      }
    });
    updateCollectionDate(formattedDate, formData.rentalDuration);
  };

  const handleDurationChange = (e) => {
    const duration = e.target.value;
    handleInputChange(e);
    updateCollectionDate(formData.deliveryDate, duration);
  };

  const updateCollectionDate = (deliveryDate, duration) => {
    if (deliveryDate && duration) {
      try {
        const collectionDate = addDays(new Date(deliveryDate), parseInt(duration));
        handleInputChange({
          target: {
            name: 'collectionDate',
            value: format(collectionDate, 'yyyy-MM-dd')
          }
        });
      } catch (error) {
        console.error("Error calculating collection date:", error);
      }
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <label htmlFor="deliveryDate" className="block text-sm font-medium text-gray-700">
          Delivery Date
        </label>
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          dateFormat="yyyy-MM-dd"
          minDate={new Date()}
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          required
        />
        {errors.deliveryDate && <p className="text-red-500 mt-1">{errors.deliveryDate}</p>}
      </div>

      <div>
        <label htmlFor="rentalDuration" className="block text-sm font-medium text-gray-700">
          Rental Duration (in days)
        </label>
        <input
          type="number"
          id="rentalDuration"
          name="rentalDuration"
          value={formData.rentalDuration}
          onChange={handleDurationChange}
          min="1"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          required
        />
        {errors.rentalDuration && <p className="text-red-500 mt-1">{errors.rentalDuration}</p>}
      </div>

      {formData.deliveryDate && formData.rentalDuration && (
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Collection Date
          </label>
          <p className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 bg-gray-50">
            {formData.collectionDate || 'Calculating...'}
          </p>
        </div>
      )}

      <div>
        <label htmlFor="deliveryInstructions" className="block text-sm font-medium text-gray-700">
          Delivery and Collection Instructions
        </label>
        <textarea
          id="deliveryInstructions"
          name="deliveryInstructions"
          value={formData.deliveryInstructions}
          onChange={handleInputChange}
          rows="3"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Please provide any specific instructions for delivery and collection of the coolroom."
        ></textarea>
        {errors.deliveryInstructions && <p className="text-red-500 mt-1">{errors.deliveryInstructions}</p>}
      </div>

      <div>
        <label htmlFor="durationComment" className="block text-sm font-medium text-gray-700">
          Additional Comments on Hire Duration
        </label>
        <textarea
          id="durationComment"
          name="durationComment"
          value={formData.durationComment}
          onChange={handleInputChange}
          rows="3"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Any additional information about the hire duration or specific requirements?"
        ></textarea>
      </div>
    </div>
  );
};

HireDurationStep.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default HireDurationStep;